import styled from "@emotion/styled";
import { Box } from "@mui/material";
import Sidedrawer from "../../SideDrawer";
import NavbarUI from "../../NavbarUI";
import { Outlet, useParams, useSearchParams } from "react-router-dom";
import CarePlanSideDrawer from "../CarePlanSideDrawer";
import CarePlanNavbar from "../CarePlanNavbar";
import { Suspense, useEffect } from "react";
import {
  getCarePlanFunc,
  getPlanVersionsListFunc,
} from "../../../actions/CarePlan";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getPatientDetailByPatientId } from "../../../actions/Patients";
import { getUnpaginatedAgentsListFunc } from "../../../actions/Agency";

const drawerWidth = 308;

const Root = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  height: "100vh",
  overflow: "hidden",
}));

const Header = styled(Box)(() => ({
  flexShrink: 0,
  width: "100%",
  height: 98,
  display: "flex",
  alignItems: "center",
  borderBottom: "1px solid #ddd",
  backgroundColor: "#F9F9FA",
  borderBottom: "1px solid #EBEBEB",
  zIndex: 10,
  padding: "24px 24px 8px 24px",
}));

const Body = styled(Box)(() => ({
  display: "flex",
  flex: 1,
  overflow: "hidden",
}));

const DrawerWrapper = styled(Box)(() => ({
  width: drawerWidth,
  flexShrink: 0,
  borderRight: "1px solid #EBEBEB",
  overflowY: "auto",
}));

const Content = styled(Box)(() => ({
  flex: 1,
  overflow: "auto",
  background: "#fff",
  // padding: "16px",
}));

const CarePlanLayout = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const getCarePlan = useSelector((state) => state.getCarePlan);
  const { carePlan } = getCarePlan;

  useEffect(() => {
    if (id && !carePlan?.care_plans[0]?.length) {
      dispatch(getPatientDetailByPatientId(id));
      dispatch(getCarePlanFunc(id));
      dispatch(getUnpaginatedAgentsListFunc());
    }
  }, [id]);

  useEffect(() => {
    if (carePlan?.care_plans[0]?.id) {
      dispatch(getPlanVersionsListFunc(carePlan?.care_plans[0]?.id));
    }
  }, [carePlan?.care_plans[0]?.id]);

  // const patientDetailByPatientId = useSelector(
  //   (state) => state.patientDetailByPatientId
  // );
  // const { patientDetail } = patientDetailByPatientId;

  // useEffect(() => {
  //   if (patientDetail?.patient?.id) {
  //     dispatch(getCarePlanFunc(patientDetail?.patient?.id));
  //   }
  // }, [patientDetail?.patient?.id]);

  return (
    <Root>
      {/* HEADER */}
      <Header>
        <CarePlanNavbar drawerWidth={drawerWidth} />
      </Header>

      {/* BODY (drawer + main content) */}
      <Body>
        <DrawerWrapper>
          <CarePlanSideDrawer drawerWidth={drawerWidth} />
        </DrawerWrapper>

        <Content>
          <Suspense fallback={null}>
            <Outlet />
          </Suspense>
        </Content>
      </Body>
    </Root>
  );
};

export default CarePlanLayout;
